import React from 'react';
import { Language, t } from '../data/translations';
import tavernBg from '../assets/ui/fantasy/tavern_bg.png';
import btnWood from '../assets/ui/fantasy/btn_wood.png';

type GameMode = 'MAIN_MENU' | 'GAME_MODE_SELECT' | 'MULTIPLAYER_MENU' | 'CREATE_ROOM' | 'JOIN_ROOM' | 'ROOM_LOBBY' | 'PLAYING' | 'OPTIONS';

interface MultiplayerMenuProps {
  onNavigate: (mode: GameMode) => void;
  onBack: () => void;
  language: Language;
}

const MultiplayerMenu: React.FC<MultiplayerMenuProps> = ({ onNavigate, onBack, language }) => {
  const commonButtonStyles: React.CSSProperties = {
    borderStyle: 'solid',
    borderWidth: '10px',
    borderImageSource: `url(${btnWood})`,
    borderImageSlice: '30 fill',
    textShadow: '1px 1px 2px black'
  };

  return (
    <div 
      className="w-full h-screen flex flex-col items-center justify-center animate-[fadeIn_0.5s_ease-out] bg-cover bg-center font-['Crimson_Text']"
      style={{ backgroundImage: `url(${tavernBg})` }}
    >
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>
      
      <div className="relative z-10 flex flex-col items-center">
        <h2 className="text-6xl font-['Cinzel'] font-black text-transparent bg-clip-text bg-gradient-to-b from-[#FFD700] via-[#FDB931] to-[#996515] drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] mb-12">
          {t('ui.multiplayer', language)}
        </h2>
        
        <div className="flex flex-col gap-6 w-96">
          <button
            onClick={() => onNavigate('CREATE_ROOM')}
            className="transition-all transform hover:scale-105 hover:brightness-110 text-amber-100 font-['Cinzel'] font-bold text-xl py-2 px-6 shadow-2xl"
            style={commonButtonStyles}
          >
            {t('ui.createRoom', language)}
          </button>
          
          <button
            onClick={() => onNavigate('JOIN_ROOM')}
            className="transition-all transform hover:scale-105 hover:brightness-110 text-amber-100 font-['Cinzel'] font-bold text-xl py-2 px-6 shadow-2xl"
            style={commonButtonStyles}
          >
            {t('ui.joinRoom', language)}
          </button>
          
          <button
            onClick={onBack}
            className="mt-6 transition-all transform hover:scale-105 hover:brightness-110 text-amber-200/70 font-['Cinzel'] font-bold text-lg py-1 px-6 shadow-xl opacity-90"
            style={commonButtonStyles}
          >
            {t('ui.back', language)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultiplayerMenu;
